import * as Sentry from '@sentry/react';
import React from 'react';

interface ErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ComponentType<{ error: Error; resetError: () => void }>;
}

const DefaultFallback: React.FC<{ error: Error; resetError: () => void }> = ({ resetError }) => (
  <div className="flex flex-col items-center justify-center min-h-screen p-4">
    <div className="text-center">
      <h2 className="text-2xl font-bold text-destructive mb-4">Something went wrong</h2>
      <p className="text-foreground mb-4">
        An unexpected error occurred. Our team has been notified.
      </p>
      <button
        onClick={resetError}
        className="px-4 py-2 bg-accent text-white rounded hover:bg-accent-dark"
      >
        Try again
      </button>
    </div>
  </div>
);

export const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({
  children,
  fallback: Fallback = DefaultFallback,
}) => {
  return (
    // @ts-expect-error - React.FC is not compatible with React.FC<ErrorBoundaryProps>
    <Sentry.ErrorBoundary fallback={Fallback} showDialog>
      {children}
    </Sentry.ErrorBoundary>
  );
};
